/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */


//---------------------------------------------------------------------------
//---------------------------------------------------------------------------

export function calcLastModified(last) {
  //https://stackoverflow.com/questions/7763327/how-to-calculate-date-difference-in-javascript
  //  const date = new Date(last);
  const secondsInAMin = 60;
  const secondsInAnHour = 60 * secondsInAMin;
  const secondsInADay = 24 * secondsInAnHour;

  let newYearDate = new Date(last);
  let currDate = new Date();

  let remainingSecondsInDateDiff = Math.abs((newYearDate - currDate) / 1000);
  let days = Math.floor(remainingSecondsInDateDiff / secondsInADay);

  let remainingSecondsAfterDays = remainingSecondsInDateDiff - (days * secondsInADay);
  let hours = Math.floor(remainingSecondsAfterDays / secondsInAnHour);

  let remainingSecondsAfterhours = remainingSecondsAfterDays - (hours * secondsInAnHour);
  let mins = Math.floor(remainingSecondsAfterhours / secondsInAMin);

  let seconds = Math.floor(remainingSecondsAfterhours - (mins * secondsInAMin));

  if (days > 0) {
    return `${days} days`;
  }
  if (hours > 0) {
    return `${hours} hours`;
  }
  if (mins > 0) {
    return `${mins} mins`;
  }

  return '< min';

}